<script lang="ts" setup>
import ProblemPresentationCard from '../ProblemPresentation/ProblemPresentationCard.vue';

defineProps<{
  imageNumber: InstanceType<
    typeof ProblemPresentationCard
  >['$props']['imageNumber'];
}>();
</script>

<template>
  <ProblemPresentationCard :image-number="imageNumber">
    <template #titleText>
      自分にあった<span :class="$style['card__text--accent']"
        >住宅ローンの選び方</span
      >を教えてほしい
    </template>
    <template #detail>
      金利タイプ（変動・固定）や団信など、自分にあった住宅ローンの選び方のアドバイスが欲しい。
    </template>
  </ProblemPresentationCard>
</template>

<style lang="scss" module>
.card {
  &__text {
    &--accent {
      color: $color-text-and-object-accent-primary;
    }
  }
}
</style>
